import { facultyApi } from '../../../services';
import {
	createStatsQueryHook,
	createChartQueryHook,
	type StatsQueryParams,
	type ChartQueryParams,
} from '../../../hooks';

export type UseFacultiesQueryParams = StatsQueryParams;
export type UseFacultiesChartParams = ChartQueryParams;

export const useFacultiesQuery = createStatsQueryHook({
	entityKey: 'faculties',
	apiFn: (params) => facultyApi.getFacultyStats(params),
});

export const useFacultiesChartQuery = createChartQueryHook({
	entityKey: 'faculties',
	apiFn: (params) => facultyApi.getNivoLineChartData(params),
});
